import { styled } from 'styled-components';
import { breakpoints, getFontSize } from '../../abstracts';
import { Text } from '../Text';
export const Container = styled.ul.withConfig({
  componentId: "aui__sc-rou16n-0"
})(["all:unset;display:flex;align-items:center;flex-wrap:nowrap;gap:var(--aui-spacing-050);overflow-x:auto;-ms-overflow-style:none;scrollbar-width:none;::-webkit-scrollbar{display:none;}", "{flex-wrap:wrap;}"], breakpoints.md);
export const Item = styled.li.withConfig({
  componentId: "aui__sc-rou16n-1"
})(["display:flex;align-items:center;gap:var(--aui-spacing-050);color:var(--aui-on-surface);[data-aui='link'],[data-aui='action.inline'],[data-aui='icon']{color:var(--aui-on-surface-soft);}> *{font-size:", ";line-height:1.5;white-space:nowrap;}&:last-child [data-aui='icon']{display:none;}"], getFontSize(1));
export const OverflowDots = styled(Text).withConfig({
  componentId: "aui__sc-rou16n-2"
})(["display:none;", "{display:inline;}"], breakpoints.md);